export const learnerInvitationsText = {
  invite: 'Add Learners',
  invited: 'Invitation Sent',
  noInvitations: 'No active invitations found',
  areYouSure: 'Are you sure you want to delete this invitation?',
};
